import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AssetQuantityField from "../../../../views/inventory/requests/AssetQuantityField";

export default function KitAssetQuantityModal({ onClose, value, onChange, availableQuantity }) {
  const [tempQuantity, setTempQuantity] = useState(value);

  const handleSave = () => {
    onChange(tempQuantity);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography fontSize={22} fontWeight={500} color="text.secondary" align="center">
          Change Required Quantity
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={4}>
          <AssetQuantityField
            quantity={tempQuantity}
            onChange={setTempQuantity}
            size="large"
            quantityProps={{
              label: "Required Quantity",
              style: { minWidth: 160 },
              InputLabelProps: {
                shrink: true,
              },
              autoFocus: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "flex-end" }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
